import React from 'react';
import {clsx} from 'clsx';

import tallyStyle from './icon.module.styl';

const ReplaysTallyIcon = ({className}: {className: string}) => {
  return (
    <div className={clsx(className, tallyStyle.iconContainer)}>
      <svg width='40' height='40' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g>
          {/* Static gray background circle */}
          <circle
            className={tallyStyle.staticStroke}
            cx='30'
            cy='30'
            r='28'
            stroke='currentColor'
            strokeWidth='2'
            fill='none'
          />

          {/* Rotating purple segments (visible when not loaded) */}
          <g className={tallyStyle.spinner}>
            <path
              className={tallyStyle.spinnerStroke}
              d='M30 2 A28 28 0 0 1 58 30'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
            />
            <path
              className={tallyStyle.spinnerStroke}
              d='M30 58 A28 28 0 0 1 2 30'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
            />
          </g>

          {/* Complete purple circle (visible when loaded) */}
          <circle
            className={tallyStyle.iconCircle}
            cx='30'
            cy='30'
            r='28'
            stroke='currentColor'
            strokeWidth='2'
            fill='none'
          />

          {/* Replays icon (always visible) */}
          <g className={tallyStyle.icon}>
            <g>
              <path
                className={tallyStyle.iconPathStroke}
                d='M18.5 3H8.5C7.94772 3 7.5 3.44772 7.5 4V14C7.5 14.5523 7.94772 15 8.5 15H18.5C19.0523 15 19.5 14.5523 19.5 14V4C19.5 3.44772 19.0523 3 18.5 3Z'
                stroke='currentColor'
                strokeWidth='1.5'
              />
              <path
                className={tallyStyle.iconPathFill}
                d='M11.5 6.8831C11.5 6.49445 11.924 6.25439 12.2572 6.45435L15.7854 8.57125C16.1091 8.76545 16.1091 9.23454 15.7854 9.42875L12.2572 11.5457C11.924 11.7456 11.5 11.5056 11.5 11.1169V6.8831Z'
                fill='currentColor'
              />
              <path
                className={tallyStyle.iconPathStroke}
                d='M4.5 6V16C4.5 17.1046 5.39543 18 6.5 18H16.5'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export {ReplaysTallyIcon};
